module.exports = __webpack_public_path__ + "img/schedule.bc7aa624.svg";